import getUrlParam from 'helpers/getUrlParam';
import _ from 'lodash';

export default class SalescampHelper {
  static localStorageKey = 'salescampReferralToken';

  static saveTokenFromUrl() {
    const token = getUrlParam('salescamp');
    if (!_.isEmpty(token)) {
      localStorage.setItem(SalescampHelper.localStorageKey, token);
    }
  }

  static getTokenFromLocalStorage() {
    return localStorage.getItem(SalescampHelper.localStorageKey);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/SalescampHelper.js